import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/people-digital-green.svg'


const _hoisted_1 = { class: "manual-underwriting-tab position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title pt-2" }, "Refer to manual underwriting", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "item-label pt-2" }, "What would you like the underwriter to know and consider?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "item-label pt-3" }, "Supporting documents", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "item-content pb-3" }, " Upload digital photos and/or scans of all documents related to this referral. ", -1)
const _hoisted_8 = { class: "row overflow-x-hidden pb-3" }
const _hoisted_9 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 center-btn" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload pe-2" }, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 card bg-light-gray p-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body item-body p-1" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" Supported file types are: "),
      /*#__PURE__*/_createElementVNode("span", { class: "item-bold" }, "jpg, jpeg, png, gif and pdf"),
      /*#__PURE__*/_createTextVNode(". Maximum number of files is 25 (up to "),
      /*#__PURE__*/_createElementVNode("b", null, "5MB"),
      /*#__PURE__*/_createTextVNode(" each). ")
    ])
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "border rounded p-3 mb-5" }
const _hoisted_15 = { class: "item-content" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { href: "mailto: underwriting@booster.co.nz" }, "underwriting@booster.co.nz", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "hr medium-bottom-spacing" }, null, -1)
const _hoisted_20 = { class: "row overflow-x-hidden" }
const _hoisted_21 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 center-btn" }
const _hoisted_22 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 text-end center-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_TextInput, {
      value: _ctx.additionalDescription,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.additionalDescription) = $event)),
      "validation-error": _ctx.readError('additionalDescription')
    }, null, 8, ["value", "validation-error"]),
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "btn btn-booster-secondary float-start",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
        }, [
          _hoisted_10,
          _createTextVNode("Upload File ")
        ]),
        _createElementVNode("input", {
          ref: "fileInput",
          type: "file",
          style: {"display":"none"},
          multiple: "",
          accept: ".jpg, .jpeg, .png, .gif, .pdf",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
        }, null, 544)
      ])
    ]),
    (_ctx.selectedFiles?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFiles, (file) => {
              return (_openBlock(), _createElementBlock("li", {
                key: file.name,
                class: "item-content"
              }, _toDisplayString(file.name), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_12,
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createTextVNode(" To speed up the underwriting process, you can "),
        _createElementVNode("a", {
          href: _ctx.documentPaths.MEDICAL_CONSENT_FORM
        }, "download the Medical Consent Form", 8, _hoisted_16),
        _createTextVNode(" for your client to sign, and send the signed form to "),
        _hoisted_17,
        _createTextVNode(". Alternatively, we will send it to the client if it's required. ")
      ])
    ]),
    _hoisted_18,
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        (_ctx.previousPath)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(["btn btn-booster-secondary float-start", {'d-none': _ctx.isMobileScreen}]),
              to: _ctx.previousPath
            }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            }, 8, ["class", "to"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          class: "btn btn-booster-primary float-end",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToNextPage()))
        }, "Submit")
      ])
    ])
  ]))
}